import * as React from 'react';
import isEqual from 'react-fast-compare';
import { tryCheckout } from '../../../cart/actions/cart-actions';
import { ItemType } from '../../../classes/item-type';
import { CartSeat } from '../../../classes/seat';
import { SeatingOptionGroup } from '../../../classes/seating-option';
import { Html } from '../../../helpers/html-helpers';
import CheckoutButton from './checkout-button';
import SubtotalItems from './subtotal-items';


export interface ICartProps {
    dispatch: any /*Dispatch<any>*/;
    itemId: number;
    itemType: ItemType;
    allowExchangesAddon: boolean;

    selectedAdditionalOptionGroups: Array<SeatingOptionGroup>; //used for non-seat bound seating options

    cartCheckoutButton: string;
    cartAddMoreButton: string;
    cartDisabled: boolean;
    cartErrorMessage: string;

    additionalNotes: string;

    cartMessage: string;
    //CartItems props
    cartSeats: Array<CartSeat>;
    cartSubtotalLabel: string;
    currencyFormat: string;
    exchangeFreeLabel: string;

    minQuantityNotReached: boolean;
    minQuantityNotReachedMessage: string;

    hidePricesInCart: boolean;
    subpackageHideMessage: string;
    displaySeatFee?: boolean;
}

interface ICartInteractionState {
    mobileCartOpen: boolean;
}

class Subtotal extends React.Component<ICartProps, ICartInteractionState>{
    constructor(props) {
        super(props);
        this.state = {
            mobileCartOpen: false,
        }
    }

    shouldComponentUpdate(nextProps: ICartProps, nextState) {
        return this.props.cartSeats.length != nextProps.cartSeats.length
            || this.props.cartDisabled != nextProps.cartDisabled
            || this.props.additionalNotes != nextProps.additionalNotes
            || !isEqual(this.props.cartSeats.map(s => s.selectedPricing.priceTypeId), nextProps.cartSeats.map(s => s.selectedPricing.priceTypeId))
            || !isEqual(this.props.selectedAdditionalOptionGroups, nextProps.selectedAdditionalOptionGroups);

    }

    render() {

        return (
            <div className="overlay-section-subtotal-container">

                {
                    this.props.cartMessage.length > 0 ?
                        Html.renderParagraph(this.props.cartMessage, "caption-paragraph") : null
                }

                {
                    this.props.minQuantityNotReached && this.props.minQuantityNotReachedMessage.length > 0 ?
                        Html.renderDiv(this.props.minQuantityNotReachedMessage, "caption-paragraph error-notice")
                        : null
                }
                {
                    this.props.cartErrorMessage.length > 0 ?
                        Html.renderDiv(this.props.cartErrorMessage, "caption-paragraph error-notice") : null
                }

                <SubtotalItems {...this.props} />

                <CheckoutButton {...this.props}
                    showAddMoreButton={this.props.itemType === ItemType.Exchange && this.props.allowExchangesAddon}
                />

            </div>
        );
    }

    _onCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, false));
    }

    _onAddMoreCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, true));
    }



}

export default Subtotal;